<template>
  <div class="status_head">
    <div class="desc">质检方案</div>
    <img src="@/assets/status_2.png" class="status_img" />

    <svg xmlns="http://www.w3.org/2000/svg" class="back" viewBox="0 0 320 512" width="19" height="19" style="fill: rgba(255, 255, 255, 1); border-color: rgba(0, 0, 0, 0); border-width: apx; border-style: undefined" filter="none">
      <path
        d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
      ></path>
    </svg>
    <svg class="back_home" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="23" height="23" style="fill: #ffffff; border-color: rgba(255, 2, 0, 0); border-width: bpx; border-style: undefined" filter="none">
      <path
        d="M16 29.333c-7.364 0-13.333-5.969-13.333-13.333s5.969-13.333 13.333-13.333 13.333 5.969 13.333 13.333-5.969 13.333-13.333 13.333zM16 26.667c5.891 0 10.667-4.776 10.667-10.667s-4.776-10.667-10.667-10.667v0c-5.891 0-10.667 4.776-10.667 10.667s4.776 10.667 10.667 10.667v0zM16 20c-2.209 0-4-1.791-4-4s1.791-4 4-4v0c2.209 0 4 1.791 4 4s-1.791 4-4 4v0z"
      ></path>
    </svg>
    <svg class="back_home sd" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="23" height="23" style="fill: #ffffff; border-color: rgba(0, 0, 0, 0); border-width: bpx; border-style: undefined" filter="none">
      <path
        d="M16 21.333c-2.945 0-5.333-2.388-5.333-5.333s2.388-5.333 5.333-5.333 5.333 2.388 5.333 5.333-2.388 5.333-5.333 5.333zM28.444 19.556c-1.964 0-3.556-1.592-3.556-3.556s1.592-3.556 3.556-3.556c1.964 0 3.556 1.592 3.556 3.556s-1.592 3.556-3.556 3.556zM3.556 19.556c-1.964 0-3.556-1.592-3.556-3.556s1.592-3.556 3.556-3.556 3.556 1.592 3.556 3.556-1.592 3.556-3.556 3.556z"
      ></path>
    </svg>
    <div class="bu_bg"></div>
  </div>
</template>
<script>
export default {
  name: 'Mpbar',
  props: {
    panelid: {
      type: Number
    }
  }
}
</script>
<style lang="scss" scoped>
.status_head {
  top: 0px;
  position: absolute;
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 375px;
  height: 64px;
  border-radius: 24px 24px 0 0;
  background: #07c160;
  z-index: 100;
  .desc {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 800;
    top: 20px;
    width: 375px;
    height: 44px;
    color: white;
  }
  .back {
    fill: white;
    position: absolute;
    top: 32px;
    left: 6px;
    width: 19px;
    height: 19px;
    z-index: 100;
  }
  .bu_bg {
    position: absolute;
    top: 24px;
    right: 9px;
    width: 96px;
    height: 34px;
    border-radius: 20px;
    background-color: rgba(255, 255, 255, 0.3);
  }
  .back_home {
    position: absolute;
    top: 30px;
    right: 23px;
    z-index: 100;
  }
  .back_home.sd {
    right: 65px;
  }
  .status_img {
    top: 0px;
    width: 375px;
  }
}
</style>